import { css } from 'styled-components';

export default css`
  transform: scale(1.2) rotate(-10deg);
`;
